import { render, staticRenderFns } from "./social-learning-modal.vue?vue&type=template&id=c24ea658&scoped=true"
import script from "./social-learning-modal.vue?vue&type=script&lang=js"
export * from "./social-learning-modal.vue?vue&type=script&lang=js"
import style0 from "./social-learning-modal.vue?vue&type=style&index=0&id=c24ea658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24ea658",
  null
  
)

export default component.exports